module.exports = __webpack_public_path__ + "static/img/yiti_03.d7a17c0b.jpg";